import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteABlog, getBlogs, resetState } from "../features/blogs/blogSlice";
import CustomModal from "../components/CustomModal";
import { delImg } from "../features/upload/uploadSlice";
import { useTheme } from "../contexts/ThemeContext";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
    className: "text-text-light dark:text-text-dark",
  },
  {
    title: "Title",
    dataIndex: "name",
    className: "text-text-light dark:text-text-dark",
  },
  {
    title: "Category",
    dataIndex: "category",
    className: "text-text-light dark:text-text-dark",
  },
  {
    title: "Action",
    dataIndex: "action",
    className: "text-text-light dark:text-text-dark",
  },
];

const Bloglist = () => {
  const [open, setOpen] = useState(false);
  const [blogId, setblogId] = useState("");
  const { darkMode } = useTheme();
  
  const showModal = (e) => {
    setOpen(true);
    setblogId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getBlogs());
  }, []);
  const getBlogState = useSelector((state) => state.blogs.blogs);
  const data1 = [];
  for (let i = 0; i < getBlogState.length; i++) {
    data1.push({
      key: i + 1,
      name: getBlogState[i].title,
      category: getBlogState[i].category,

      action: (
        <>
          <Link
            to={`/admin/blog/${getBlogState[i].id}`}
            className=" fs-3 text-success dark:text-green-400 hover:text-green-600 dark:hover:text-green-300 transition-colors duration-200"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0 dark:text-red-400 hover:text-red-600 dark:hover:text-red-300 transition-colors duration-200"
            onClick={() => showModal(getBlogState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteBlog = (e) => {
    dispatch(deleteABlog(e));
    dispatch(delImg(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getBlogs());
    }, 100);
  };
  return (
    <div className="bg-background-light dark:bg-background-dark p-4">
      <h3 className="mb-4 title text-2xl font-bold">Blogs List</h3>
      <div className="bg-white dark:bg-surface-dark p-2 md:p-4 rounded-xl shadow dark:shadow-gray-800">
        <Table 
          columns={columns} 
          dataSource={data1} 
          scroll={{ x: true }}
          size="small"
          pagination={{
            pageSize: 10,
            responsive: true,
            className: "text-text-light dark:text-text-dark",
          }}
        />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteBlog(blogId);
        }}
        title="Are you sure you want to delete this blog?"
      />
    </div>
  );
};

export default Bloglist;